import React from "react";


export const FormInfoAlert = props => <>
  <div class="alert alert-info">
    <p>{props.value}</p>
  </div>
</>
